import * as React from 'react';
import {observer} from 'mobx-react';
import {CreditCards} from './credit-cards';
import {style} from 'typestyle';
import {px} from 'csx';
import {CardSchema} from '../types/schema';

export interface PageAccountBillingCreditCardsModel {
  cards: Array<CardSchema>;
}

export interface PageAccountBillingCreditCardsProps {
  model: PageAccountBillingCreditCardsModel;
  onAddCard?(): void;
  onEditCard?(identity: string): void;
  onRemoveCard?(identity: string): void;
  i18n?: {
    title: string;
    add: string;
  }
}

const DEFAULT_I18N = {
  title: 'Credit cards',
  add: 'Add a new card',
};

export const PageAccountBillingCreditCards = observer<PageAccountBillingCreditCardsProps>(
  ({ i18n = DEFAULT_I18N, model, onAddCard, onEditCard, onRemoveCard }) => (
    <div className={styles.container} >
      <h2>{i18n.title}</h2>
      <CreditCards
        model={model}
        onAddCard={onAddCard}
        onEditCard={onEditCard}
        onRemoveCard={onRemoveCard}
      />
    </div>
  )
);


const styles = {
  container: style({
    marginBottom: px(40)
  })
};